import { css, styled } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const Chip = styled.div<{ $hasOnRemove: boolean }>`
  ${({ theme: { colors, fontSizes, fontWeights }, $hasOnRemove }) => css`
    align-items: center;
    background: ${colors.brandDarkTint95};
    border-radius: 0.25rem;
    cursor: default;
    display: flex;
    gap: 0.25rem;
    padding: 0.25rem 0.25rem 0.25rem 0.5rem;
    user-select: none;

    ${
      !$hasOnRemove &&
      css`
        padding-right: 0.5rem;
      `
    }

    p {
      font-size: ${fontSizes.s12};
      font-weight: ${fontWeights.medium};
      margin: 0;
    }

    div {
      align-items: center;
      display: flex;
      gap: 0.25rem;

      img {
        object-fit: cover;
        object-position: center;
        border-radius: 1rem;
        width: 1rem;
        height: 1rem;
      }

      .icon {
        width: 1rem;
        height: 1rem;
      }

      span {
        font-size: ${fontSizes.s12};
        line-height: 1.25rem;
      }

      .avatar {
        align-items: center;
        background: ${colors.brandPrimary};
        border-radius: 1rem;
        display: flex;
        height: 1rem;
        justify-content: center;
        width: 1rem;

        p {
          font-size: 0.625rem;
          line-height: 1em;
          margin: 0;
          padding: 0;
        }
      }
    }

    .button {
      border-radius: 0.25rem;
      height: 1.5rem;
      width: 1.5rem;
      min-width: unset;

      .icon {
        font-size: 0.875em;
      }
    }
  `}
`;
